import "core-js/modules/es.symbol";
import "core-js/modules/es.symbol.description";
import "core-js/modules/es.symbol.iterator";
import "core-js/modules/es.array.concat";
import "core-js/modules/es.array.from";
import "core-js/modules/es.array.is-array";
import "core-js/modules/es.array.iterator";
import "core-js/modules/es.array.map";
import "core-js/modules/es.array.slice";
import "core-js/modules/es.date.to-string";
import "core-js/modules/es.function.name";
import "core-js/modules/es.object.to-string";
import "core-js/modules/es.regexp.to-string";
import "core-js/modules/es.string.iterator";
import "core-js/modules/web.dom-collections.iterator";

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import React, { useState } from 'react';
import PropTypes from 'prop-types';
import Block from '../../../block/Block';
import Tabs from '../../../tabs/Tabs';
import Tab from '../../../tabs/Tab';
import TabList from '../../../tabs/TabList';
import TabPanels from '../../../tabs/TabPanels';
import TabPanel from '../../../tabs/TabPanel';
import CmsContent from '../../CmsContent';
import styles from './EnhancedTabs.less';
export var EnhancedTabsDesktop = function EnhancedTabsDesktop(_ref) {
  var tabs = _ref.tabs,
      tabExist = _ref.tabExist,
      metadata = _ref.metadata;

  var _useState = useState(0),
      _useState2 = _slicedToArray(_useState, 2),
      activeTab = _useState2[0],
      setActiveTab = _useState2[1];

  var _ref2 = metadata || {},
      _ref2$background = _ref2.background;

  _ref2$background = _ref2$background === void 0 ? {} : _ref2$background;
  var backgroundColor = _ref2$background.Key,
      backgroundColorAlt = _ref2$background.key;
  return /*#__PURE__*/React.createElement(Block, {
    className: "".concat(styles['enhanced-tabs-wrapper'], " clearFloat ").concat(backgroundColor || backgroundColorAlt),
    "data-en": 'cms-tabs',
    layout: true,
    vertical: true
  }, /*#__PURE__*/React.createElement(Block, {
    flex: true
  }, /*#__PURE__*/React.createElement(Tabs, {
    activeTabIndex: activeTab,
    onSelectTab: setActiveTab
  }, /*#__PURE__*/React.createElement(TabList, null, tabExist ? tabs.map(function (content, index) {
    var _ref3 = content || {},
        title = _ref3.title;

    return title ? /*#__PURE__*/React.createElement(Tab, {
      key: index
    }, /*#__PURE__*/React.createElement(CmsContent, {
      content: title
    })) : null;
  }) : null), /*#__PURE__*/React.createElement(TabPanels, null, tabExist ? tabs.map(function (content, index) {
    var _ref4 = content || {},
        text = _ref4.text;

    return text ? /*#__PURE__*/React.createElement(TabPanel, {
      key: index
    }, /*#__PURE__*/React.createElement(CmsContent, {
      content: text
    })) : null;
  }) : null))));
};
EnhancedTabsDesktop.propTypes = {
  tabs: PropTypes.array,
  tabExist: PropTypes.bool,
  metadata: PropTypes.object
};
export default EnhancedTabsDesktop;